<div class="modal-header" data-cy="workflowTaskModalModalHeader">
	<h2 class="modal-title">
		@if (task() === null) {
			Create New Task Set
		} @else {
			Edit Task Set: <strong>{{ task().taskName }}</strong>
		}
	</h2>
	<button type="button" class="btn btn-close" aria-label="Close" (click)="close()" data-cy="closeModal">
		<i class="fal fa-xmark"></i>
	</button>
</div>
@if (task() === null) {
	<aw-wizard [awNavigationMode] class="rl-wizard mt-3" navBarLayout="small" [disableNavigationBar]="true">
		<aw-wizard-step [stepTitle]="'Add Details'">
			<div class="modal-body" data-cy="workflowTaskModalModalBody">
				<rl-workflow-task-form #wfTaskForm [charTypeId]="charTypeId()" [processId]="processId()"
					[task]="task()"></rl-workflow-task-form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()" data-cy="workflowTaskModalCancel">
					Cancel
				</button>
				<button type="button" class="btn btn-info" data-cy="workflowTaskModalNext"
					[disabled]="!wfTaskForm.isDirty || !wfTaskForm.isValid" rlBusyButton
					(click)="saveOperation(wfTaskForm.mappedTask)">
					Next<i class="fal fa-chevron-right ms-1"></i>
				</button>
			</div>
		</aw-wizard-step>
		<aw-wizard-step [stepTitle]="'Add Tasks'">
			<div class="modal-body" data-cy="workflowTaskModalModalBody">
				<rl-workflow-task-group-form #taskGroupForm [charTypeId]="charTypeId()" [processId]="processId()"
					[task]="updatedTask()"></rl-workflow-task-group-form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()" data-cy="workflowTaskModalCancel">
					Cancel
				</button>
				<button type="button" class="btn btn-success" (click)="saveSet(taskGroupForm.buildTaskControlGroup())"
					[disabled]="!taskGroupForm.isDirty || !taskGroupForm.isValid" data-cy="workflowTaskModalClose"
					rlBusyButton>
					Save
				</button>
			</div>
		</aw-wizard-step>
	</aw-wizard>
} @else {
	<div class="modal-body" data-cy="workflowTaskModalModalBody">
		<rl-workflow-task-form #wfTaskForm [charTypeId]="charTypeId()" [processId]="processId()"
			[task]="task()"></rl-workflow-task-form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="close()" data-cy="workflowTaskModalCancel">
			Cancel
		</button>
		<button type="button" class="btn btn-success" data-cy="workflowTaskModalNext"
			[disabled]="!wfTaskForm.isDirty || !wfTaskForm.isValid" rlBusyButton
			(click)="saveOperation(wfTaskForm.mappedTask)">
			Save
		</button>
	</div>
}